import React, { useEffect, useState } from 'react';
import styles from '../flaviacunha/flaviacunha.module.scss';
import perfil from '../flaviacunha/src/perfil.png';
import InstagramIcon from '../../icons/instagramIcon.tsx';
import TiktokIcon from '../../icons/tiktokIcon.tsx';
import WhatsappIcon from '../../icons/whatsappIcon.tsx';

const EMAIL = 'creator.flaviacunha@gmail.com';
const WHATSAPP_NUMBER = '553199498433';
const INSTAGRAM_URL =
    'https://www.instagram.com/flavia.cunha__?utm_source=ig_web_button_share_sheet&igsi=ZDNlZDc0MzIxNw==';
const TIKTOK_URL = 'https://www.tiktok.com/@flavia.cunha__?_r=1&_t=ZS-96wIFiKWbrU';
const ICON_COLOR = '#d8c09a';

type CupomCard = {
    id: number;
    image: string;
    brand: string;
    cupom?: string;
    desconto?: string;
    site: string;
    ctaLabel?: string;
    modal: true;
};

type ContactCard = {
    id: number;
    image: string;
    brand: string;
    email: string;
    whatsapp: string;
    modal: 'contact';
};

type LinkCard = {
    id: number;
    image: string;
    link: string;
    modal?: false;
};

type ModalCard = CupomCard | ContactCard;
type CardItem = CupomCard | ContactCard | LinkCard;

const cardImages: CardItem[] = [
    {
        id: 13,
        image: require('./src/cards/13.png'),
        brand: 'Contatos',
        email: EMAIL,
        whatsapp: WHATSAPP_NUMBER,
        modal: 'contact',
    },
    {
        id: 14,
        image: require('./src/cards/14.png'),
        brand: 'Levê Studio',
        cupom: 'FLACUNHA',
        site: 'https://uselevestudio.com.br/',
        modal: true,
    },
    // {
    //     id: 1,
    //     image: require('./src/cards/1.png'),
    //     brand: 'Adaptogen',
    //     cupom: 'FLACUNHA',
    //     site: 'https://adaptogen.com.br/?cupom=flacunha',
    //     modal: true,
    // },
    // {
    //     id: 2,
    //     image: require('./src/cards/2.png'),
    //     brand: 'Maxfem',
    //     cupom: 'FLACUNHA',
    //     site: 'https://mais.app/XaziV6',
    //     modal: true,
    // },
    {
        id: 3,
        image: require('./src/cards/3.png'),
        brand: 'Blessy',
        cupom: 'FLACUNHA',
        site: 'https://useblessy.com.br/discount/FLACUNHA',
        modal: true,
    },
    // {
    //     id: 4,
    //     image: require('./src/cards/4.png'),
    //     brand: 'Beleza Brasileira',
    //     cupom: 'FLACUNHA',
    //     site: 'https://belezabrasileira.com.br/',
    //     modal: true,
    // },
    {
        id: 5,
        image: require('./src/cards/5.png'),
        brand: 'Liquidz',
        cupom: 'FLAVIACUNHA',
        site: 'https://oferta.liquidz.com.br/comprar?utm_source=instagram&utm_medium=influencer&utm_campaign=FLAVIACUNHA',
        modal: true,
    },
    // {
    //     id: 6,
    //     image: require('./src/cards/6.png'),
    //     brand: 'Hey! Mu',
    //     cupom: 'FLACUNHA',
    //     site: 'https://www.heymu.com.br/',
    //     modal: true,
    // },
    // {
    //     id: 7,
    //     image: require('./src/cards/7.png'),
    //     brand: 'Saint Germain',
    //     cupom: 'A-FLAVIACUNHPA',
    //     site: 'https://www.saintgermainbrand.com.br/',
    //     modal: true,
    // },
    // {
    //     id: 8,
    //     image: require('./src/cards/8.png'),
    //     brand: 'Aura Beauty',
    //     cupom: 'FLACUNHA',
    //     site: 'https://aurabeautyclub.com.br/',
    //     modal: true,
    // },
    // {
    //     id: 9,
    //     image: require('./src/cards/9.png'),
    //     brand: 'Gocase',
    //     cupom: 'FLAVIACUNHA',
    //     site: 'https://www.gocase.com.br/',
    //     modal: true,
    // },
    // {
    //     id: 10,
    //     image: require('./src/cards/10.png'),
    //     brand: 'RenovaBe',
    //     cupom: 'FLAVIA10',
    //     site: 'https://renovabe.com.br/?utm_source=google&utm_medium=cpc&utm_campaign=_&utm_content=_&utm_term=renova+be&gad_source=1&gad_campaignid=23509696742&gclid=Cj0KCQjw16_UBhCqARIsAIdOaXygfLeaZYrNZCaH-p_PonkFVlUlMi5FMU-C4o1K0sHLZvja2H4ru64aAqQ2EALw_wcB',
    //     modal: true,
    // },
    {
        id: 11,
        image: require('./src/cards/11.png'),
        link: 'https://collshp.com/flaviacunhalj?view=storefront',
    },
    {
        id: 12,
        image: require('./src/cards/12.png'),
        link: 'https://chat.whatsapp.com/DUSMuvy1Dgb7LhAsPEhiA1?s=cl&p=i&mlu=4',
    },
];

const Flaviacunha: React.FC = () => {
    const [activeCard, setActiveCard] = useState<ModalCard | null>(null);
    const [copied, setCopied] = useState(false);

    useEffect(() => {
        if (!activeCard) return;

        const onKeyDown = (e: KeyboardEvent) => {
            if (e.key === 'Escape') setActiveCard(null);
        };

        const prevOverflow = document.body.style.overflow;
        document.body.style.overflow = 'hidden';
        window.addEventListener('keydown', onKeyDown);

        return () => {
            document.body.style.overflow = prevOverflow;
            window.removeEventListener('keydown', onKeyDown);
        };
    }, [activeCard]);

    useEffect(() => {
        setCopied(false);
    }, [activeCard]);

    const handleCopy = async () => {
        if (activeCard?.modal !== true || !activeCard.cupom) return;
        try {
            await navigator.clipboard.writeText(activeCard.cupom);
            setCopied(true);
            window.setTimeout(() => setCopied(false), 1800);
        } catch {
            setCopied(false);
        }
    };

    return (
        <div className={styles.flaviacunha}>
            <div className={styles.container}>
                <img src={perfil} alt="Perfil" className={styles.perfil} />
                <div className={styles.socialRow}>
                    <a
                        href={`mailto:${EMAIL}`}
                        className={styles.socialLink}
                        aria-label="E-mail"
                    >
                        <svg
                            height="24"
                            width="24"
                            viewBox="0 0 24 24"
                            xmlns="http://www.w3.org/2000/svg"
                            aria-hidden="true"
                        >
                            <path
                                fill={ICON_COLOR}
                                d="M20 4H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 4-8 5L4 8V6l8 5 8-5v2z"
                            />
                        </svg>
                    </a>
                    <a
                        href={INSTAGRAM_URL}
                        target="_blank"
                        rel="noopener noreferrer"
                        className={styles.socialLink}
                        aria-label="Instagram"
                    >
                        <InstagramIcon height="22" color={ICON_COLOR} />
                    </a>
                    <a
                        href={TIKTOK_URL}
                        target="_blank"
                        rel="noopener noreferrer"
                        className={styles.socialLink}
                        aria-label="TikTok"
                    >
                        <TiktokIcon height="22" color={ICON_COLOR} />
                    </a>
                </div>
                <div className={styles.cards}>
                    {cardImages.map((card) =>
                        card.modal ? (
                            <button
                                type="button"
                                key={card.id}
                                className={styles.card}
                                onClick={() => setActiveCard(card)}
                                aria-label={`Abrir ${card.brand}`}
                            >
                                <img src={card.image} alt={card.brand} />
                            </button>
                        ) : (
                            <a
                                href={card.link}
                                target="_blank"
                                rel="noopener noreferrer"
                                key={card.id}
                                className={styles.card}
                            >
                                <img src={card.image} alt={`Card ${card.id}`} />
                            </a>
                        )
                    )}
                </div>
            </div>

            {activeCard && (
                <div
                    className={styles.modalOverlay}
                    onClick={() => setActiveCard(null)}
                    role="presentation"
                >
                    <div
                        className={styles.modal}
                        role="dialog"
                        aria-modal="true"
                        aria-labelledby="flaviacunha-modal-title"
                        onClick={(e) => e.stopPropagation()}
                    >
                        <button
                            type="button"
                            className={styles.modalClose}
                            onClick={() => setActiveCard(null)}
                            aria-label="Fechar"
                        >
                            ×
                        </button>

                        {activeCard.modal === 'contact' ? (
                            <>
                                <p className={styles.modalEyebrow}>Parcerias</p>
                                <h2 id="flaviacunha-modal-title" className={styles.modalBrand}>
                                    {activeCard.brand}
                                </h2>
                                <div className={styles.contactActions}>
                                    <a
                                        href={`mailto:${activeCard.email}`}
                                        className={styles.contactBtnEmail}
                                    >
                                        <svg
                                            height="22"
                                            width="22"
                                            viewBox="0 0 24 24"
                                            xmlns="http://www.w3.org/2000/svg"
                                            aria-hidden="true"
                                        >
                                            <path
                                                fill="currentColor"
                                                d="M20 4H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 4-8 5L4 8V6l8 5 8-5v2z"
                                            />
                                        </svg>
                                        <span>E-mail</span>
                                    </a>
                                    <a
                                        href={`https://wa.me/${activeCard.whatsapp}`}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        className={styles.contactBtnWhatsapp}
                                    >
                                        <WhatsappIcon height="22" color="currentColor" />
                                        <span>WhatsApp</span>
                                    </a>
                                </div>
                            </>
                        ) : (
                            <>
                                <p className={styles.modalEyebrow}>
                                    {activeCard.cupom ? 'Cupom exclusivo' : 'Oferta exclusiva'}
                                </p>
                                <h2 id="flaviacunha-modal-title" className={styles.modalBrand}>
                                    {activeCard.brand}
                                </h2>

                                {activeCard.cupom ? (
                                    <div className={styles.cupomBox}>
                                        <span className={styles.cupomLabel}>Seu cupom</span>
                                        <span className={styles.cupomCode}>{activeCard.cupom}</span>
                                        {activeCard.desconto ? (
                                            <span className={styles.cupomDesconto}>{activeCard.desconto}</span>
                                        ) : null}
                                        <button
                                            type="button"
                                            className={styles.copyBtn}
                                            onClick={handleCopy}
                                        >
                                            {copied ? 'Copiado!' : 'Copiar cupom'}
                                        </button>
                                    </div>
                                ) : activeCard.desconto ? (
                                    <div className={styles.cupomBox}>
                                        <span className={styles.cupomLabel}>Desconto</span>
                                        <span className={styles.cupomCode}>{activeCard.desconto}</span>
                                    </div>
                                ) : (
                                    <div className={styles.cupomBoxEmpty}>
                                        <span className={styles.cupomLabel}>Cupom</span>
                                        <span className={styles.cupomEmptyText}>
                                            Em breve um cupom exclusivo para você
                                        </span>
                                    </div>
                                )}

                                <a
                                    href={activeCard.site}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className={styles.siteBtn}
                                >
                                    {activeCard.ctaLabel ?? 'Ir para o site'}
                                </a>
                            </>
                        )}
                    </div>
                </div>
            )}
        </div>
    );
};

export default Flaviacunha;
